import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ChatMessageContentProps {
  children: React.ReactNode;
}

const ContentComponent: React.FC<ChatMessageContentProps> = ({ children }) => {
  return <div className="peptalk-chat-message-content">{children}</div>;
};

export const Content: React.FC<ChatMessageContentProps> = (
  props: ChatMessageContentProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatMessageContent',
    Component: ContentComponent,
  });

  return <Component {...props} />;
};
